/**
 * Orders
 */

// React
import React, { FunctionComponent, useEffect, useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
import useQuery from '../../utils/hook/useQuery';

// Context
import AuthContext, { AuthConsumer } from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getOrdersAction,
  updateOrderStatusActions,
  updateAllOrderStatusActions,
  actionRetrieveRubikaOrdersAction,
  cancelOrderAction,
  getAllOrdersReportAction,
} from './actions';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectOrdersList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectAllOrders,
  makeSelectProcessingCountList,
  makeSelectDeliveredCountList,
  makeSelectDeliveringCountList,
  makeSelectDeliverdPostCountList,
} from './selectors';

// UI
import theme from '../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountKeyOutline,
  mdiAccountOutline,
  mdiPhoneOutline,
  mdiHomeSearchOutline,
  mdiPackageVariant,
  mdiStateMachine,
  mdiCalendar,
  mdiClose,
  mdiHomeCityOutline,
  mdiPencilOutline,
  mdiPostOutline,
  mdiPlus,
  mdiPost
} from '@mdi/js';
import { Box, Trolley, Truck, Deliverd } from './customIcon';

// Components
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import type { Filter } from '../../utils/listDaynamicFilter';
import List from './list';
import Pagination from '@material-ui/lab/Pagination';
import Can from '../../components/Can';
import CSV from './csv';
import ExelExport from './components/exelExport';
import partnerRepository from 'client-sdk/src/Repository/partners-repository';
// Helper
import {
  removeEmptyValueObject,
  translateOrderStatus,
  checkMatchMedia,
} from '../../utils/helpers';

// Type
import {
  Props,
  SelectorProps,
  Payload,
  Status,
  cancelPayload,
  PayloadAllUpdate,
} from './interfaces';
import handleError from '../../utils/handleError';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transform: 'translateY(-3px)',
      boxShadow: '-6px 6px 14px 0px rgba(0,0,0,0.15) !important',
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    cardContent: {
      marginTop: '-22px',
      display: 'flex',
    },
    hover: {
      '&:hover': {
        curser: 'pointer',
      },
    },
    mdiDresserIcon: {
      color: '#329926',

      // backgroundColor: '#D6EBD3',
    },
    mdiClipboardMultipleOutlineIcon: {
      color: '#6276F7',
    },
    chart: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    progress: {
      padding: '24px',
      height: '312px',
      backgroundColor: 'white',
      width: '100%',
      overflow: 'visible',
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      paddingTop: '8px',
      paddingRight: '24px',
      paddingBottom: '8px',
      paddingLeft: '50px',
      marginLeft: '-35px',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    closeIcon: {
      color: '#EC4040',
      backgroundColor: '#F7B3B3',
      borderRadius: '5px',
      padding: '5px',
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    btnBox: {
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 768px)': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
    },
  })
);

const Orders: FunctionComponent<Props> = (props: Props) => {
  const authContext = useContext(AuthContext);
  const [filters, setFilters] = useState([] as Filter[]);
  const { filtersValues, setFiltersValues } = useQuery({ page: 0, size: 10 });
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openConfirmCancel, setOpenConfirmCancel] = useState(false as boolean);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [id, setId] = useState(-1 as number);
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [cancelDescription, setCancelDescription] = useState('' as string);
  const filterTranslator = (fieldName: string) => {
    const status = {
      customerName: 'نام سفارش دهنده',
      'customerName.equals': 'نام سفارش دهنده:',
      'customerName.contains': 'نام سفارش دهنده:',
      trackingCode: 'کد پیگیری',
      'trackingCode.equals': 'کد پیگیری',
      'trackingCode.contains': 'کد پیگیری',
      'id.equals': 'کد سفارش:',
      'id.contains': 'کد سفارش:',
      deliveryType: 'نوع ارسال',
      'deliveryType.equals': 'نوع ارسال:',
      'deliveryType.contains': 'نوع ارسال:',
      centerName: 'مرکز سفارش',
      'centerName.equals': 'مرکز سفارش:',
      'centerName.contains': 'مرکز سفارش:',
      deliveryDate: 'زمان تحویل',
      'deliveryDate.equals': 'زمان تحویل:',
      'deliveryDate.contains': 'زمان تحویل:',
      status: 'وضعیت سفارش',
      'status.in': 'وضعیت سفارش:',
      'status.notIn': 'وضعیت سفارش:',
    };
    return status[fieldName];
  };
  const removeFilterHandler = (fieldName: any) => {
    const filtered = { ...filtersValues };
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };
  const convertArrayItemsToString = () => {
    const array = props.allOrders;
    const reducer = (total: any, currentValue: any) => total + currentValue;
    const newArray = array.map(obj => {
      return {
        ...obj,
        items: obj.items.reduce(reducer).productName,
      };
    });
    return newArray;
  };

  useEffect(() => {
    getOrders();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const getOrders = () => {
    const { page, size } = filtersValues;
    props.ordersDispatch({
      ...filtersValues,
      page,
      size,
    });
  };

  const setupFilters = () => {
    Can({
      role: authContext.user.role,
      perform: 'orders:filtersByCenterId',
      yes: () => {
        setFilters([
          {
            type: 'input',
            id: 'customerName.contains',
            label: 'نام سفارش‌دهنده',
            icon: mdiAccountOutline,
          },
          {
            type: 'input',
            id: 'customerMobileNumber.contains',
            label: 'شماره همراه سفارش‌دهنده',
            icon: mdiPhoneOutline,
          },
          {
            type: 'input',
            id: 'id.equals',
            label: 'شناسه سفارش',
            icon: mdiPackageVariant,
          },
          {
            type: 'input',
            id: 'trackingCode.contains',
            label: 'کد پیگیری',
            icon: mdiPackageVariant,
          },
          {
            type: 'input',
            id: 'customerNationalCode.contains',
            label: 'کد  ملی',
            icon: mdiPackageVariant,
          },

          {
            type: 'input',
            id: 'centerName.contains',
            label: 'نام مرکز',
            icon: mdiHomeSearchOutline,
          },
          {
            type: 'input',
            id: 'partnerName.contains',
            label: 'نام شرکت',
            icon: mdiHomeCityOutline,
          },
          {
            type: 'input',
            id: 'customerProvinceName.contains',
            label: 'نام استان',
            icon: mdiHomeCityOutline,
          },
          {
            type: 'input',
            id: 'customerCity.contains',
            label: 'نام شهر',
            icon: mdiHomeCityOutline,
          },

          {
            type: 'date-picker-time',
            id: 'created.greaterThanOrEqual',
            label: 'تاریخ ثبت سفارش از ',
            icon: mdiCalendar,
          },
          {
            type: 'date-picker-time',
            id: 'created.lessThanOrEqual',
            label: 'تا تاریخ ثبت سفارش  ',
            icon: mdiCalendar,
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.greaterThanOrEqual',
            label: 'تاریخ تحویل از ',
            icon: mdiCalendar,
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.lessThanOrEqual',
            label: '  تا تاریخ تحویل ',
            icon: mdiCalendar,
          },
          {
            type: 'checkbox',
            id: 'status.in',
            label: 'وضعیت سفارش',
            icon: mdiStateMachine,
            data: [
              'ORDERED',
              'DELIVERED_TO_POST',
              'DELIVERED_TO_CENTER',
              'SUPPLIED_IN_CENTER',
              'PACKAGED',
              'BUNDLED',
              'LOADED',
              'ARRIVED',
              'DELIVERED',
              'NOT_DELIVERED',
              'RETURNED',
              'CANCELLED',
            ],
            translateType: 'order',
          },
        ]);
      },
      no: () => {
        setFilters([
          {
            type: 'input',
            id: 'customerName.contains',
            label: 'نام سفارش‌دهنده',
            icon: mdiAccountOutline,
          },
          {
            type: 'input',
            id: 'customerPhoneNumber.contains',
            label: 'شماره همراه سفارش‌دهنده',
            icon: mdiPhoneOutline,
          },
          {
            type: 'input',
            id: 'id.equals',
            label: 'شناسه سفارش',
            icon: mdiPackageVariant,
          },

          // {
          //   type: 'input',
          //   id: 'trackingCode.contains',
          //   label: 'شناسه پیگیری',
          // },

          {
            type: 'input',
            id: 'customerNationalCode.contains',
            label: 'کد  ملی',
            icon: mdiAccountKeyOutline,
          },
          {
            type: 'input',
            id: 'partnerName.contains',
            label: 'شرکت',
            icon: mdiHomeSearchOutline,
          },
          {
            type: 'input',
            id: 'partnerName.doesNotContain',
            label: 'شرکتها(به جز)',
            icon: mdiHomeSearchOutline,
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.greaterThanOrEqual',
            label: 'تاریخ تحویل از ',
            icon: mdiCalendar,
          },
          {
            type: 'date-picker',
            id: 'deliveryDate.lessThanOrEqual',
            label: '  تا تاریخ تحویل ',
            icon: mdiCalendar,
          },
          {
            type: 'checkbox',
            id: 'status.in',
            label: 'وضعیت سفارش',
            icon: mdiStateMachine,
            data: [
              'ORDERED',
              'DELIVERED_TO_POST',
              'DELIVERED_TO_CENTER',
              'SUPPLIED_IN_CENTER',
              'PACKAGED',
              'BUNDLED',
              'LOADED',
              'ARRIVED',
              'DELIVERED',
              'NOT_DELIVERED',
              'RETURNED',
              'CANCELLED',
            ],
            translateType: 'order',
          },
          {
            type: 'input',
            id: 'postTrackingCode.equals',
            label: 'کدرهگیری پست',
            icon: mdiPost,
          },
          {
            type: 'input',
            id: 'trackingCode.equals',
            label: 'کد پیگیری',
            icon: mdiPostOutline,
          },
        ]);
      },
    });
  };
  let headCells = [];

  Can({
    role: authContext.user.role,
    perform: 'orders:list:centerName',
    yes: () => {
      headCells = [
        {
          id: 'customerName',
          label: 'نام سفارش‌دهنده',
          type: 'input',
        },
        { id: 'partnerName', label: 'نام شرکت', type: 'input' },
        { id: 'id', label: 'کد سفارش', type: 'input' },
        { id: 'trackingCode', label: 'کد پیگیری', type: 'input' },
        { id: 'deliveryType', label: 'نوع ارسال', type: 'input' },
        { id: 'centerName', label: 'مرکز سفارش', type: 'input' },
        {
          id: 'deliveryDate',
          label: 'زمان تحویل',
          type: 'date-picker',
        },
        {
          id: 'status',
          label: 'وضعیت سفارش',
          type: 'checkbox',
          data: [
            'ORDERED',
            'DELIVERED_TO_POST',
            'DELIVERED_TO_CENTER',
            'SUPPLIED_IN_CENTER',
            'PACKAGED',
            'BUNDLED',
            'LOADED',
            'ARRIVED',
            'DELIVERED',
            'NOT_DELIVERED',
            'RETURNED',
            'CANCELLED',
          ],
          translateType: 'Order',
        },
      ];
    },
    no: () => {
      headCells = [
        {
          id: 'customerName',
          label: 'نام سفارش‌دهنده',
        },
        { id: 'partnerName', label: 'نام شرکت', type: 'input' },
        { id: 'id', label: 'شناسه سفارش' },
        { id: 'trackingCode', label: 'کد پیگیری' },
        { id: 'deliveryType', label: 'نوع ارسال' },
        {
          id: 'deliveryDate',
          label: 'زمان تحویل',
        },
        { id: 'status', label: 'وضعیت سفارش' },
      ];
    },
  });
  const head = { headCells };
  const handleCancelOrder = async () => {
    await props.cancelOrderDispatch({
      id,
      body: { description: cancelDescription },
    });
    getOrders();
    setOpenConfirmCancel(false);
  };

  const handleCardClose = () => {
    delete filtersValues['status.in'];
    setFiltersValues({
      ...removeEmptyValueObject(filtersValues),

      page: 0,
      size: 10,
    });
  };
  const handleCardClick = (name: any) => {
    switch (name) {
      case 'progress':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['ASSIGNED', 'PICKED', 'PACKAGED', 'BUNDLED'],

          page: 0,
          size: 10,
        });
        break;
      case 'courier':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['LOADED', 'DELIVERED_TO_COURIER'],

          page: 0,
          size: 10,
        });
        break;
      case 'delivered':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['DELIVERED'],
          page: 0,
          size: 10,
        });
        break;
      case 'post':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['DELIVERED_TO_POST'],
          page: 0,
          size: 10,
        });
        break;
    }
  };

  const changeStatusOrder = () => {
    props.updateOrderStatusDispatch({
      id,
      body: { status: previewState, description: '' },
      pagination: filtersValues,
    });
    setOpenConfirmUpdateState(false);
  };
  const changeStatusOrderWhitId = (data: any) => {
    const { ids, status, description } = data;
    props.updateAllOrderStatusDispatch({
      ids,
      status,
      description,
      pagination: filtersValues,
    });

    // props.updateOrderStatusDispatch({
    //   id,
    //   body,
    //   pagination: filtersValues,
    // });
    setOpenConfirmUpdateState(false);
  };

  const handleOpenConfirmCancele = (id: number) => {
    setOpenConfirmCancel(true);
    setId(id);
  };
  const handleOpenConfirmUpdateState = (data: { id: number; body: Status }) => {
    setOpenConfirmUpdateState(true);
    setId(data.id);
    setPreviewState(data.body);
  };

  const handleClose = () => {
    setOpenConfirmCancel(false);
    setOpenConfirmUpdateState(false);
    setOpenSize(false);
  };

  const findOrderStatus = (id: number) => {
    const status = props.ordersList.find(order => order.id === id)?.status;
    return status && translateOrderStatus(status);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const checkActiveCard = (name: string) => {
    const status = filtersValues['status.in']?.split(',') || [];
    switch (name) {
      case 'progress':
        return (
          status.includes('ASSIGNED') &&
          status.includes('PICKED') &&
          status.includes('PACKAGED') &&
          status.includes('BUNDLED')
        );
      case 'courier':
        return (
          status.includes('LOADED') && status.includes('DELIVERED_TO_COURIER')
        );
      case 'delivered':
        return status.includes('DELIVERED');
      case 'post':
        return status.includes('DELIVERED_TO_POST');
    }
  };

  return (
    <AuthConsumer>
      {({ user }) => (
        <div className={classes.root}>
          <Grid container spacing={5}>
            <Grid container item xs={12} sm={6} alignItems="center">
              <Typography
                variant="h4"
                component="div"
                style={{ marginLeft: '20px', fontSize: '18px' }}
              >
                {`مدیریت سفارش‌ها`}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <RenderFilter
                filters={filters}
                onFilter={(filtervalues: any) => {
                  setFiltersValues({
                    ...removeEmptyValueObject(filtervalues),
                    page: 0,
                    size: 10,
                  });
                }}
                mainFiltersCount={0}
                baseFilter={{
                  type: 'input',
                  id: 'id.equals',
                  placeholder: 'شناسه سفارش ',
                }}
                filterValues={filtersValues}
              />
            </Grid>

            <Grid xs={12} sm={3} item container alignItems="center">
              {props.loading ? (
                ''
              ) : (
                <>
                  {props.ordersList.length > 0 && (
                    <>
                      <div
                        className={classes.subtitle}
                      >{`تعداد کل سفارش‌ها:`}</div>
                      <div>
                        &nbsp;
                        <b>{`${props.count}`}</b>
                      </div>
                    </>
                  )}
                </>
              )}
            </Grid>
            <Grid
              container
              item
              xs={12}
              md={9}
              direction="row-reverse"
              alignItems="center"
            >
              <div className={classes.btnBox}>
                <Can
                  role={user.role}
                  perform="orders:grouping-create"
                  yes={() => (
                    <>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{ marginRight: '5px' }}
                        onClick={() =>
                          props.history.push('/create-grouping-order')
                        }
                        startIcon={<Icon path={mdiPlus} size={1} />}
                        size={
                          checkMatchMedia('(max-width: 1024px)')
                            ? 'small'
                            : 'large'
                        }
                      >{`ثبت دسته‌جمعی سفارش`}</Button>
                    </>
                  )}
                />

                <Can
                  role={user.role}
                  perform="orders:btnGetNewOrders"
                  yes={() => (
                    <>
                      <Button
                        variant="contained"
                        color="secondary"
                        size={
                          checkMatchMedia('(max-width: 1024px)')
                            ? 'small'
                            : 'large'
                        }
                        onClick={() =>
                          props.actionRetrieveRubikaOrdersDispatch({})
                        }
                      >{`دریافت سفارش جدید`}</Button>
                    </>
                  )}
                />

                <Can
                  role={user.role}
                  perform="orders:create"
                  yes={() => (
                    <>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => props.history.push('/orders-create')}
                        startIcon={<Icon path={mdiPlus} size={1} />}
                        size={
                          checkMatchMedia('(max-width: 1024px)')
                            ? 'small'
                            : 'large'
                        }
                      >{`ایجاد سفارش جدید`}</Button>
                    </>
                  )}
                />

                <Can
                  role={user.role}
                  perform="orders:downloadReportCSV"
                  yes={() => (
                    <>
                      <CSV
                        ordersDispatch={props.allOrdersDispatch}
                        data={props.allOrders}
                        filtersValues={filtersValues}
                        loading={props.loading}
                      />
                      <ExelExport
                        data={convertArrayItemsToString()}
                        loading={props.loading}
                        filtersValues={filtersValues}
                        handleRequest={props.allOrdersDispatch}
                      />
                    </>
                  )}
                />
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            md={12}
            style={{
              maxWidth: '120%',
              margin: '32px 1px',
            }}
          >
            <Grid container item lg={12} spacing={2} xs={12}>
              <Grid item md={6} lg={3} xs={6}>
                <Card
                  className={
                    checkActiveCard('progress')
                      ? classes.boxshadow
                      : classes.cards
                  }
                >
                  <CardHeader
                    action={
                      checkActiveCard('progress') && (
                        <IconButton
                          aria-label="close"
                          onClick={handleCardClose}
                          className={classes.iconHeader}
                        >
                          <Icon
                            path={mdiClose}
                            size={1}
                            style={{
                              color: '#Ffffff',
                              backgroundColor: '#FFA65A',
                              borderRadius: '3px',
                            }}
                          />
                        </IconButton>
                      )
                    }
                  />
                  <CardContent className={classes.cardContent}>
                    <IconButton
                      type="submit"
                      onClick={name => handleCardClick('progress')}
                      aria-label="search"
                      style={{
                        backgroundColor: '#FFEDDE',
                        height: '30%',
                        width: '28%',
                        borderRadius: '4px',
                        margin: '-20px 0',
                      }}
                    >
                      <Trolley />
                    </IconButton>
                    <Grid
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        marginRight: '10px',
                      }}
                    >
                      <Typography
                        variant="h6"
                        component="h6"
                        style={{ fontWeight: 600, marginTop: '-20px' }}
                      >
                        {props.processingCount}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: '16px',
                          marginBottom: '-20px',
                          fontWeight: 550,
                          color: '#666666',
                        }}
                      >
                        در حال پردازش
                      </Typography>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={6} lg={3} xs={6}>
                <Card
                  className={
                    checkActiveCard('courier')
                      ? classes.boxshadow
                      : classes.cards
                  }
                >
                  <CardHeader
                    action={
                      checkActiveCard('courier') && (
                        <IconButton
                          aria-label="close"
                          onClick={handleCardClose}
                          className={classes.iconHeader}
                        >
                          <Icon
                            path={mdiClose}
                            size={1}
                            style={{
                              color: '#Ffffff',
                              backgroundColor: '#FFA65A',
                              borderRadius: '3px',
                            }}
                          />
                        </IconButton>
                      )
                    }
                  />
                  <CardContent className={classes.cardContent}>
                    <IconButton
                      type="submit"
                      aria-label="search"
                      onClick={name => handleCardClick('courier')}
                      style={{
                        backgroundColor: '#DFE3FD',
                        height: '60%',
                        width: '30%',
                        borderRadius: '4px',
                        margin: '-20px 0',
                      }}
                    >
                      <Truck />
                    </IconButton>
                    <Grid
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        marginRight: '10px',
                      }}
                    >
                      <Typography
                        variant="h6"
                        component="h6"
                        style={{ fontWeight: 600, marginTop: '-20px' }}
                      >
                        {props.deliveringCount}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: '16px',
                          marginBottom: '-20px',
                          fontWeight: 550,
                          color: '#666666',
                        }}
                      >
                        تحویل پیک شده
                      </Typography>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={6} lg={3} xs={6}>
                <Card
                  className={
                    checkActiveCard('post') ? classes.boxshadow : classes.cards
                  }
                >
                  <CardHeader
                    action={
                      checkActiveCard('post') && (
                        <IconButton
                          aria-label="close"
                          onClick={handleCardClose}
                          className={classes.iconHeader}
                        >
                          <Icon
                            path={mdiClose}
                            size={1}
                            style={{
                              color: '#Ffffff',
                              backgroundColor: '#FFA65A',
                              borderRadius: '3px',
                            }}
                          />
                        </IconButton>
                      )
                    }
                  />

                  <CardContent className={classes.cardContent}>
                    <IconButton
                      type="submit"
                      aria-label="search"
                      onClick={name => handleCardClick('post')}
                      style={{
                        backgroundColor: '#E9CAF2',
                        height: '50%',
                        width: '30%',
                        borderRadius: '4px',
                        margin: '-20px 0',
                      }}
                    >
                      <Deliverd />
                    </IconButton>
                    <Grid
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        marginRight: '10px',
                      }}
                    >
                      <Typography
                        variant="h6"
                        component="h6"
                        style={{ fontWeight: 600, marginTop: '-20px' }}
                      >
                        {props.deliverdPostCount}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: '16px',
                          marginBottom: '-20px',
                          fontWeight: 550,
                          color: '#666666',
                        }}
                      >
                        تحویل پست
                      </Typography>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={6} lg={3} xs={6}>
                <Card
                  className={
                    checkActiveCard('delivered')
                      ? classes.boxshadow
                      : classes.cards
                  }
                >
                  <CardHeader
                    action={
                      checkActiveCard('delivered') && (
                        <IconButton
                          aria-label="close"
                          onClick={handleCardClose}
                          className={classes.iconHeader}
                        >
                          <Icon
                            path={mdiClose}
                            size={1}
                            style={{
                              color: '#Ffffff',
                              backgroundColor: '#FFA65A',
                              borderRadius: '3px',
                            }}
                          />
                        </IconButton>
                      )
                    }
                  />
                  <CardContent className={classes.cardContent}>
                    <IconButton
                      type="submit"
                      aria-label="search"
                      onClick={name => handleCardClick('delivered')}
                      style={{
                        padding: '17px 0',
                        backgroundColor: '#D6EBD3',
                        height: '50%',
                        width: '30%',
                        borderRadius: '4px',
                        margin: '-20px 0',
                      }}
                    >
                      <Box />
                    </IconButton>
                    <Grid
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        marginRight: '10px',
                      }}
                    >
                      <Typography
                        variant="h6"
                        component="h6"
                        style={{ fontWeight: 600, marginTop: '-20px' }}
                      >
                        {props.deliveredCount}
                      </Typography>
                      <Typography
                        style={{
                          fontSize: '16px',
                          marginBottom: '-20px',
                          fontWeight: 550,
                          color: '#666666',
                        }}
                      >
                        تحویل مشتری
                      </Typography>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            {/* <Grid item lg={4} xs={6}>
          <Card className={classes.chart}>
            <Grid
              style={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Typography className={classes.typographyCards}>
                تعداد آیتم‌های محموله
              </Typography>
              <Select value={'۷ روز گذشته'}>
                <MenuItem value={'۷ روز گذشته'}>۷ روز گذشته</MenuItem>
              </Select>
            </Grid>
            <div style={{marginTop: '10px'}}>
              <Chart data={data} height={230}>
                <ArgumentAxis />
                <ValueAxis position={'right'} />

                <LineSeries valueField="value" argumentField="argument" />
                <EventTracker />
                <Tooltip />
              </Chart>
            </div>
          </Card>
        </Grid> */}
            {/* <Grid item lg={3} xs={6}>
          <Card className={classes.progress}>
            <Typography
              className={classes.typographyCards}
              style={{
                width: '60%',
                textAlign: 'end',
              }}
            >
              محموله هر انبار
            </Typography>
            <div style={{textAlign: 'center', margin: '30px auto'}}>
              <CircularProgress
                size={140}
                style={{
                  position: 'relative',
                  color: '#6276F7',
                  // bottom: '-20%',
                  // right: '30%',
                }}
                variant="determinate"
                value={60}
                thickness={6}
              />
              <Typography
                style={{
                  position: 'relative',
                  bottom: '85px',
                  fontWeight: 900,
                }}
                variant="caption"
                component="div"
                color="textSecondary"
              >
                {'754 سفارش'}
              </Typography>
            </div>
          </Card>
        </Grid> */}
          </Grid>
          <Grid container spacing={3} style={{ marginTop: '32px' }}>
            <Grid item xs={12}>
              {props.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                <>
                  {props.ordersList?.length > 0 ? (
                    <List
                      data={props.ordersList}
                      handleConfirmCanceleBox={handleOpenConfirmCancele}
                      changeStatusOrderWhitId={changeStatusOrderWhitId}
                      handleOpenConfirmUpdateState={
                        handleOpenConfirmUpdateState
                      }
                      head={head}
                      filterVal={filtersValues}
                      onFilterValue={(filtervalues: any) => {
                        setFiltersValues({
                          ...removeEmptyValueObject(filtervalues),
                          ...filtersValues,
                          page: 0,
                          size: 10,
                        });
                      }}
                      removeFilterHandler={removeFilterHandler}
                      filterLabelTranslator={filterTranslator}
                    />
                  ) : (
                    <Typography variant="h3" component="div">
                      سفارشی موجود نیست
                    </Typography>
                  )}
                </>
              )}
            </Grid>
            <Grid item xs={12} sm={6}>
              {props.ordersList.length > 0 && (
                <FormControl
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                    {' '}
                    تعداد نمایش در هر صفحه:
                  </div>
                  <Select
                    open={openSize}
                    onClose={handleClose}
                    onOpen={() => setOpenSize(true)}
                    value={filtersValues.size}
                    onChange={handleChangeSizePage}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
              )}
            </Grid>
            <Grid xs={12} sm={6} container item direction="row-reverse">
              {props.ordersList.length > 0 && (
                <Pagination
                  className={classes.pagination}
                  count={Math.ceil(props.count / filtersValues.size)}
                  color="secondary"
                  page={filtersValues.page + 1}
                  onChange={handleChangePage}
                />
              )}
            </Grid>
          </Grid>

          <Dialog
            open={openConfirmCancel}
            fullWidth
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                {handleClose ? (
                  <IconButton
                    aria-label="close"
                    // className={classes.closeButton}
                    onClick={handleClose}
                  >
                    <Icon path={mdiClose} size={1} />
                  </IconButton>
                ) : null}
              </div>
              <div className={classes.cancelIcon}>
                <Icon
                  path={mdiClose}
                  size={4}
                  color={theme.palette.error.main}
                />
              </div>
              <div
                className={classes.cancelTitle}
              >{`از لغو سفارش با شناسه ${id} مطمئن هستید؟`}</div>
              <TextField
                className={classes.textArea}
                placeholder={`علت لغو...`}
                value={cancelDescription}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setCancelDescription(e.target.value)
                }
              />
            </DialogContent>
            <DialogActions className={classes.actionsBox}>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Button
                    fullWidth
                    autoFocus
                    onClick={handleClose}
                    variant="contained"
                    color="secondary"
                    size="large"
                  >
                    {`خیر`}
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={handleCancelOrder}
                    disabled={!(cancelDescription.length > 0)}
                    size="large"
                  >
                    {`بله`}
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </Dialog>

          <Dialog
            fullWidth
            open={openConfirmUpdateState}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                {handleClose ? (
                  <IconButton
                    aria-label="close"
                    // className={classes.closeButton}
                    onClick={handleClose}
                  >
                    <Icon path={mdiClose} size={1} />
                  </IconButton>
                ) : null}
              </div>
              <div className={classes.editIcon}>
                <Icon
                  path={mdiPencilOutline}
                  size={4}
                  color={theme.palette.blue.main}
                />
              </div>
              <div className={classes.cancelTitle}>
                {`از تغییر تگ وضعیت سفارش
                با شناسه  ${id} از
 "${id > -1 && findOrderStatus(id)}"
 به
" ${translateOrderStatus(previewState.replace(/"/g, '') as Status)}"

 
 مطمئن هستید؟`}
              </div>
            </DialogContent>
            <DialogActions className={classes.actionsBox}>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Button
                    fullWidth
                    autoFocus
                    onClick={handleClose}
                    variant="contained"
                    color="secondary"
                    size="large"
                  >
                    {`خیر`}
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={changeStatusOrder}
                    size="large"
                  >
                    {`بله`}
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </AuthConsumer>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  allOrders: makeSelectAllOrders(),
  count: makeSelectCountList(),
  deliveringCount: makeSelectDeliveringCountList(),
  deliveredCount: makeSelectDeliveredCountList(),
  processingCount: makeSelectProcessingCountList(),
  deliverdPostCount: makeSelectDeliverdPostCountList(),
  loading: makeSelectLoading(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ordersDispatch: (payload: Payload) => dispatch(getOrdersAction(payload)),
    allOrdersDispatch: (payload: Payload) =>
      dispatch(getAllOrdersReportAction(payload)),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateOrderStatusActions(payload)),
    updateAllOrderStatusDispatch: (payload: PayloadAllUpdate) =>
      dispatch(updateAllOrderStatusActions(payload)),
    actionRetrieveRubikaOrdersDispatch: (payload: {
      date?: String;
      from?: number;
      to?: number;
    }) => dispatch(actionRetrieveRubikaOrdersAction(payload)),
    cancelOrderDispatch: (payload: cancelPayload) =>
      dispatch(cancelOrderAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Orders);
